import {computed, onMounted, ref, watch} from "vue";
import {useQuery, useQueryClient} from "@tanstack/vue-query";
import axios from "axios";

const useWebsite = () => {
  const { data, refetch, isLoading, isRefetching } = useQuery({
    queryKey: ['current-website'],
    queryFn: () => axios.get('/ajax/v2/website'),
  });

  const website = computed(() => data.value?.data?.data);
  const websiteId = computed(() => website.value?.id);
  const activeWebsiteIsFreeAppsumo = computed(() => {
    const appsumoCode = website.value?.appsumo_code;
    return appsumoCode !== null && appsumoCode !== undefined;
  });
  return {
    website,
    refetchWebsite: refetch,
    isLoading,
    isRefetching,
    websiteId,
    activeWebsiteIsFreeAppsumo,
  };
};

export default useWebsite;
